export interface CaseStudy {
    slug: string;
    pageTitle: string;
    pageDescription: string;
    pageImage: string;
    mainImage: {
        url: string;
        childImageSharp: {
            fluid: any;
        }
    };
    brandImage: {
        childImageSharp: {
            fluid: any;
        }
    };
    caseTitle: string;
    caseDescription?: string;
    caseName: string;
    caseDate: string;
    mainContent: string;
    aboutTheBrand: string;
    aboutTheBrandTitle: string;
    showStats: boolean;
    stats: {
        statIcon: string;
        statLabel: string;
        statNumber: number;
    }[];
    jumboImage: {
        url: string;
    };
}


export function trimString(str: string, length: number) {
    if (str.length > length){
        str = str.substr(0,length);
        return str.substr(0,Math.min(str.length,str.lastIndexOf(" "))) + ' [...]';
    } else{
        return str;
    }
}